module.exports = __webpack_public_path__ + "img/envision2.207f39d2.jpg";